export default __webpack_public_path__ + "static/media/celebration-woman.47b600e5.png";